const deepGet = (obj: Record<PropertyKey, any>, keys: PropertyKey[]): any => {
  let rtn: any = obj;

  const found = keys.every(key => {
    if (typeof rtn === 'object' && rtn) {
      rtn = rtn[key];
      return true;
    }
    return false;
  });

  if (found) return rtn;

  return undefined;
};

export default deepGet;
